const addFeaturedTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute("disabled");
    else prevBtn.setAttribute("disabled", "disabled");

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute("disabled");
    else nextBtn.setAttribute("disabled", "disabled");
  };

  emblaApi
    .on("select", togglePrevNextBtnsState)
    .on("init", togglePrevNextBtnsState)
    .on("reInit", togglePrevNextBtnsState);

  return () => {
    prevBtn.removeAttribute("disabled");
    nextBtn.removeAttribute("disabled");
  };
};

const addFeaturedPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaApi.scrollNext();
  };
  prevBtn.addEventListener("click", scrollPrev, false);
  nextBtn.addEventListener("click", scrollNext, false);

  const removeFeaturedTogglePrevNextBtnsActive =
    addFeaturedTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn);

  return () => {
    removeFeaturedTogglePrevNextBtnsActive();
    prevBtn.removeEventListener("click", scrollPrev, false);
    nextBtn.removeEventListener("click", scrollNext, false);
  };
};

// Grab wrapper nodes
var emblaNodes = document.querySelectorAll(".embla-featured-collection");
var options = { align: "start", loop: false, watchDrag: true };

// Loop through all instances of embla
emblaNodes.forEach(function (emblaNode) {
  // Grab viewport node
  const viewportNode = emblaNode.querySelector(
    ".embla-featured-collection__viewport"
  );
  // Grab button nodes
  const prevBtnNode = emblaNode.querySelector(
    ".embla-featured-collection__button--prev"
  );
  const nextBtnNode = emblaNode.querySelector(
    ".embla-featured-collection__button--next"
  );

  // Initialize the carousel
  const emblaApi = EmblaCarousel(viewportNode, options);

  // Add click listeners
  const removeFeaturedPrevNextBtnsClickHandlers =
    addFeaturedPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode);

  emblaApi.on("destroy", removeFeaturedPrevNextBtnsClickHandlers);
});
